import { useQuery } from "@apollo/client";
import { Grid, makeStyles, useMediaQuery, useTheme } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import Moment from "react-moment";
import { GET_SCHEDULE_BY_MONTH } from "../../../../quries/schedule";

interface ScheduleBoardProps {
  match: any;
}

const useStyles = makeStyles((theme) => ({
  scheduleList: {
    // fontSize: 16,
    fontFamily: "'Noto Sans KR'",
    // paddingTop: 32,
    // paddingLeft: 32,
    // paddingRight: 32,
    padding: 48,
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    fontWeight: 400,
    // borderBottom: "1px solid #CCC",
    "& > :first-child": {},
    "& > :last-child": {
      borderBottom: "0px solid rgba(0, 0, 0, 0.42) !important",
    },
    [theme.breakpoints.down("md")]: { padding: 0, paddingTop: 16 },
  },
  dateCss: {
    textAlign: "right",
    fontWeight: 300,
    [theme.breakpoints.down("md")]: { fontSize: 14 },
  },
  textCss: {
    fontWeight: 500,
    paddingRight: 32,
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    [theme.breakpoints.down("md")]: { fontSize: 16, paddingRight: 0 },
  },
}));

function ScheduleBoard({ match }: ScheduleBoardProps) {
  const classes = useStyles();
  const theme = useTheme();
  const mdMatches = useMediaQuery(theme.breakpoints.down("md"));
  const [schedule, setSchedule] = useState<any>(null);
  const [nowMonth, setNowMonth] = useState<any>(null);

  const { data, error, loading } = useQuery(GET_SCHEDULE_BY_MONTH, {
    variables: {
      sort: "schedule_date:DESC",
      limit: 10,
      start: (match.params.page_id - 1) * 10,
    },
  });

  useEffect(() => {
    if (data) {
      setSchedule(data.schedules);
    }
    return () => {
      setSchedule(null);
    };
  }, [data]);

  if (loading) return null;
  if (data === undefined) return null;
  if (error || !data.schedules) {
    console.log(error);
  }

  if (schedule) {
    return (
      <Grid xs={12} item className={classes.scheduleList}>
        {schedule.map((element: any, index: any) => {
          return (
            <Grid
              container
              xs={12}
              item
              alignItems={"center"}
              key={`scheduleList-${element.schedule_date}-${index}`}
              style={{
                paddingBottom: 4,
                paddingTop: 4,
                borderBottom: "1px solid #CCC",
              }}
            >
              <Grid xs={!mdMatches ? 7 : 12} item className={classes.textCss}>
                {element.schedule_text}
              </Grid>
              {!mdMatches ? (
                <Grid xs={5} item className={classes.dateCss}>
                  <Moment locale="ko" format="YYYY년 MMM Do">
                    {element.schedule_date}
                  </Moment>
                </Grid>
              ) : null}
            </Grid>
          );
        })}
      </Grid>
    );
  } else {
    return <div></div>;
  }
}

export default ScheduleBoard;
